import { defineStyleConfig } from "@chakra-ui/react";

const InputStyle = defineStyleConfig({
  variants: {
    outline: {
      field: {
        background: "white",
      },
    },
  },
});

export default InputStyle;
